import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductFilterService } from '../Services/productfilter';
import { ProductFilter } from '../Models/filter';

@Component({
  selector: 'active-filter',
  templateUrl: '../Templates/activefilter.html',
})


export class ActiveFilterComponent {

  @Input()
  public filter: ProductFilter;

  @Output()
  public filterChange: EventEmitter<ProductFilter> = new EventEmitter();

  constructor(
    private productFilterService: ProductFilterService,
  ) {}

  private removeFilter(name: string, id: number) {

    this.filter.unsetval(name, id);

    if (name == 'category') {
      // only if exactly one category is checked, load the corresponding sizes
      // it's too confusing to have e.g. shoe sizes + dress sizes in one filter
      if (this.filter['category'].length !== 1) {
        this.productFilterService.size = []; // reset size filter
        this.filter.size = [];
      } else {
        this.productFilterService.getFilteredSizes(this.filter['category']);
      }
    }

    this.filterChange.next(this.filter);
  }

  public isChecked(category, id: number) {
    return this.filter[category].indexOf(id) > -1;
  }

  getFilterName(filterCategory: string, id: number): string {
    return this.productFilterService.getFilterName(filterCategory, id);
  }

  anyFilterActive(): boolean {

    for (let key of this.filter.keys()) {
      if (this.filter[key] && this.filter[key].length) {
        return true;
      }
    }
    return false;
  }

  isArray(val: any): boolean {

    return typeof val === typeof [];
  }

  filterKeys(): string[] {

    var no_show: string[] = ['ordering', 'limit'];

    return this.filter.keys().filter(
      (v) => { return no_show.indexOf(v) == -1 } );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/activefilter.ts